import { SearchResults } from "./search-results/SearchResults";
import { NoResults, SearchResultsDisplayComponentProps } from "@kaltura/mediaspace-shared-search";
import { ReactElement } from "react";
import { ExtraHeaderBaseProps, SearchResultsResponse } from "@kaltura/mediaspace-shared-media-list";
import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";

export interface SearchResultsDataProps extends SearchResultsDisplayComponentProps<SearchResultsResponse> {
    onData?: (data: SearchResultsResponse) => void;
    onAllSelected?: (checked: boolean) => void;
    noMediaComponentProps?: any;
    noMediaComponent: (props: any) => ReactElement;
    additionalInvalidation?: () => void;
    header?: KmsTypeComponent<any, ExtraHeaderBaseProps>;
}

/**
 * search result data for suspense below
 */
export function SearchResultsData(props: SearchResultsDataProps) {
    const {
        isSearch,
        isTextSearch,
        fetchModuleData,
        onEntryShowMore,
        page,
        onPageChange,
        pageSize,
        isWideLayout,
        searchInLabel,
        bulkButtonActions,
        bulkMenuActions,
        onInvalidate,
        onData,
        onAllSelected,
        noMediaComponent: NoMediaComponent,
        noMediaComponentProps,
        additionalInvalidation,
        filterValues,
        areSearchResultsDraggable = false,
        header,
    } = props;

    const { data } = fetchModuleData();
    onData?.(data);

    return (
        <>
            {data && (
                <SearchResults
                    {...data}
                    isTextSearch={isTextSearch}
                    page={page}
                    onPageChange={onPageChange}
                    onAllSelected={onAllSelected}
                    pageSize={pageSize}
                    onEntryShowMore={onEntryShowMore}
                    isWideLayout={isWideLayout}
                    searchInLabel={searchInLabel}
                    bulkButtonActions={bulkButtonActions}
                    bulkMenuActions={bulkMenuActions}
                    onInvalidate={onInvalidate}
                    additionalInvalidation={additionalInvalidation}
                    filterValues={filterValues}
                    areSearchResultsDraggable={areSearchResultsDraggable}
                    header={header}
                />
            )}
            {!data && isSearch && <NoResults screenMode="nomatches" />}
            {!data && !isSearch && <NoMediaComponent {...noMediaComponentProps} />}
        </>
    );
}
